export enum TaskProcessTypeEnum {
    NEW = 'New',
    RECURRING = 'Recurring',
    AD_HOC = 'AdHoc',
}
